<template>
  <v-dialog v-model="dialog" persistent max-width="400">
    <v-card grid-list-md>
      <ModelTitle title="Edit Merchent" @close="close()" />

      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field outlined autofocus dense v-model="Merchent.name" :error-messages="nameErrors"
              :hide-details="nameErrors.length === 0" label="Account Name"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field outlined dense :error-messages="sourceErrors" :hide-details="sourceErrors.length === 0"
              v-model="Merchent.sourceKey" label="Source Key"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field outlined dense :error-messages="pinErrors" :hide-details="pinErrors.length === 0"
              v-model="Merchent.pin" label="PIN"></v-text-field>
          </v-col>
          <!-- <v-col cols="12">
            <v-text-field outlined dense :error-messages="apiKeyErrors" :hide-details="apiKeyErrors.length === 0"
              v-model="Merchent.apiKey" label="API Key"></v-text-field>
          </v-col> -->
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close()">Close</v-btn>
        <v-btn color="primary" :loading="loading" dark @click="submit()">Update</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from "vuex";
import merchantService from "@/modules/Merchant/service.js";
import GlobalFunction from "@/mixins/GlobalFunction";

const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");
const noSpaces = value => /^[^\s]+$/.test(value);

export default {
  name: "edit-Merchent-dialog",
  props: {
    editDialog: {
      type: Boolean,
      default: false
    },
    merchantObj: {
      type: Object,
    }
  },
  data() {
    return {
      loading: false,
      dialog: false,
      Merchent: {
        name: null,
        sourceKey: null, // Added apiKey
        pin: null, // Added apiKey
        apiKey: null, // Added apiKey
      },
    };
  },
  mixins: [validationMixin, GlobalFunction],
  validations: {
    Merchent: {
      name: {
        required,
      },
      sourceKey: { required, noSpaces }, // Added validation for apiKey
      pin: { required, noSpaces }, // Added validation for apiKey
    },
  },
  watch: {
    editDialog(val){
      this.Merchent = JSON.parse(JSON.stringify(this.merchantObj));
      this.dialog = val;
    }
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    nameErrors() {
      const errors = [];
      if (!this.$v.Merchent.name.$dirty) return errors;
      if(!this.$v.Merchent.name.required) errors.push("Name is required");
      return errors;
    },
    sourceErrors() {
      const errors = [];
      if (!this.$v.Merchent.sourceKey.$dirty) return errors;
      if (!this.$v.Merchent.sourceKey.required) errors.push("Source Key is required");
      if (this.$v.Merchent.sourceKey.$error) errors.push("Source Key cannot contain spaces");
      return errors;
    },
    pinErrors() {
      const errors = [];
      if (!this.$v.Merchent.pin.$dirty) return errors;
      if (!this.$v.Merchent.pin.required) errors.push("Pin Key is required");
      if (this.$v.Merchent.pin.$error) errors.push("Pin Key cannot contain spaces");
      return errors;
    }
    
  },
  methods: {
    close() {
      this.$emit("close");
      this.Merchent = {
        name: null,
        sourceKey: null, // Added apiKey
        pin: null, // Added apiKey
        apiKey: null, // Added apiKey
      }
    },
    submit() {
  this.$v.$touch();
  if (this.$v.$invalid) {
    this.$swal
      .mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      })
      .fire({
        icon: "error",
        title: this.$t("toastMessage.text.invalidFields"),
      });
  } else {
    this.loading = true;
    // const MerchentObj = {
    //   name: this.Merchent.name,
    //   apiKey: this.Merchent.apiKey  // Update to include only apiKey
    // }
    return merchantService.update(this.merchantObj.id, this.Merchent)
      .then(response => {
        if (response.status) {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "success",
              title: "Merchent is updated",
            });
          this.loading = false;
          this.$emit("submit");
          this.close();
        }
      })
      .catch(error => {
        this.loading = false;
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: error.data.message,
          });
      });
  }
}
  }
};
</script>




<style scoped></style>
